import { render, staticRenderFns } from "./FloatBall.vue?vue&type=template&id=567fe392&scoped=true"
import script from "./FloatBall.vue?vue&type=script&lang=js"
export * from "./FloatBall.vue?vue&type=script&lang=js"
import style0 from "./FloatBall.vue?vue&type=style&index=0&id=567fe392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567fe392",
  null
  
)

export default component.exports